const NS = 'RegionStorePopup';
const CLS = 'regionStorePopup';
const CLS_IS_SELECTED = 'is-selected';
export const EVT_SET_REGION = `${CLS}.setStore`;

import * as Api from '../../../../global/js/api';
import GoogleMapsApi from '../../../../global/js/googleMapsApi';
import {saveSelectedStore, checkLocalStorage, storeNameShorter} from '../../../../global/js/findInStore';
import * as checkout from '../../../../global/js/checkout';
import {handleTimeOutRequest} from '../../../../global/js/cart';
import {dispatchEvent} from '../../../../global/js/utils';
export class RegionStorePopup {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.gmapApi = new GoogleMapsApi('callback_regionStorePopup');
		this.tableContainer = this.$el.find('.regionStorePopup-body');
		this.resultsContainer = this.$el.find('.regionStorePopup-tbody');
		this.regionDetail = $('.siteHeader-regionDetail');
		this.storeSelected = $('.siteHeader-regionDetail .selected-store');
		this.modal = $(`#${CLS}-modal`);
		this.storeInfo = {
			storeId: '',
			storeName: '',
			contentLinkID: '',
			regionId: '',
			branchSearch: '',
		};
	}

	init() {
		this.initCustomEvent();
		this.initPopup();
		this.handleStoreClick();
		this.handleEventModal();
	}

	initCustomEvent() {
		this.el.addEventListener(EVT_SET_REGION, (e) => {
			let localStorage = checkLocalStorage();
			this.storeInfo = localStorage.storeInfo;
			this.regionDetail.addClass('selected');
			this.storeSelected.html(storeNameShorter(this.storeInfo.storeName));
		});
	}

	initPopup() {
		const This = this;
		const $pg = $(this.$el);
		let googleApiKey = window.googleApiKey;
		let locationInput = $pg.find('#input-search-store');

		let localStorage = checkLocalStorage();
		this.storeInfo = localStorage.storeInfo;
		if (this.storeInfo.storeName) {
			this.regionDetail.addClass('selected');
			this.storeSelected.html(storeNameShorter(this.storeInfo.storeName));
		}

		$('.regionStorePopup-formInput .btn-search').on('click', function() {
			This.geoLocSearchCall();
		});

		locationInput.on('input', function() {
			let $val = $(this).val();
			setTimeout(function() {
				if (locationInput.val() == $val) { // check if value has changed within the set timeout value
					if ($val.length > 1 && !window.callInProgress) {
						window.callInProgress = true;
						This.geoLocSearchCall();
					}
				}
			}, 500); // 1/2 sec delay to check if user is done typing
		});

		// clicks outside pg and outside the results wrapper will close it and clear its content
		$(document).on('click', function(event) {
			if (!$(event.target).closest('#input-search-store, .predictions-results').length) {
				let resultsWrapper = $pg.find('.predictions-results');
				resultsWrapper.find('ul').empty();
				resultsWrapper.removeClass('is-active');
			}
		});

		this.gmapApi.load(googleApiKey);

		$pg.on('click', '.predictions-results li:not(.empty-result)', function() {
			let text = $(this).text();
			locationInput.val(text);
			// carry on with the previous sequence of finding the stores
			// hide results
			let resultsWrapper = $pg.find('.predictions-results');
			resultsWrapper.find('ul').empty();
			resultsWrapper.removeClass('is-active');
			This.storeInfo.branchSearch = text;
			This.initPostcodeSearch();
		});

		// Handle click store in case fallback
		$pg.on('change', '#selectBoxStore', function(_, data) {
			This.storeInfo.regionId = data.value;
			const storeList = JSON.parse(data.store);
			This.initPostcodeSearch(storeList);
		});
	}

	handleEventModal() {
		const $html = $('html');
		let scrollTop = 0;
		$('.regionStorePopup-modal, .storeAvailNew-modal')
			.on('show.bs.modal', () => {
				scrollTop = $html.scrollTop();
				$html.css({
					top: -scrollTop + 'px',
					width: '100vw',
					position: 'fixed',
					overflow: 'hiden',
				});
			})
			.on('hide.bs.modal', () => {
				$html.css({
					top: '',
					width: '',
					position: '',
					overflow: '',
				});
				$html.scrollTop(scrollTop);
			});
	}

	geoLocSearchCall() {
		let This = this;
		let $pg = this.$el;
		window.$storePopup = $pg;
		let searchTerm = $pg.find('#input-search-store').val();
		let iconSpinner = $pg.find('.icon-spinner');
		let cntry = 'NZL';
		handleTimeOutRequest(
			(resolve, reject) => {
				try {
					this.gmapApi.getPlacePredictions(searchTerm, {
						offset: searchTerm.length,
						componentRestrictions: {country: cntry},
						types: ['(regions)'],
					}).then((response)=> {
						let predictions = response.predictions;
						let status = response.status;
						resolve({
							predictions,
							status,
						});
					}).catch((error)=> {
						resolve(error);
					});
				} catch (error) {
					reject(error);
				}
			},
			this.displayGeoLocResults,
			this.displayChoseStoreFallback.bind(this)
		);

		iconSpinner.addClass('is-active');
	}

	displayChoseStoreFallback() {
		this.$el.find('.regionStorePopup-normal').hide();
		this.$el.find('.regionStorePopup-fallback').show();
	}

	displayGeoLocResults(predictions, status) {
		let resultsWrapper = window.$storePopup.find('.predictions-results');
		resultsWrapper.find('ul').empty();
		resultsWrapper.addClass('is-active');
		// eslint-disable-next-line no-undef
		if (status !== 'OK') {
			// an error occurd or no results
			resultsWrapper.find('ul').append(`<li class="empty-result">No results found. Please try a more generic keyword.</li>`);
		} else {
			predictions.forEach(function(prediction) {
				let predTypes = prediction.types;
				if (
					$.inArray('country', predTypes) == -1 &&
					$.inArray('point_of_interest', predTypes) == -1
				) {
					resultsWrapper.find('ul').append(`<li>${prediction.description}</li>`);
				}
			});
		}
		window.callInProgress = false;
		window.$storePopup.find('.icon-spinner').removeClass('is-active');
	}

	initPostcodeSearch(storeList = null) {
		const $pg = $(this.$el);
		const This = this;
		let iconSpinner = $pg.find('.icon-spinner');
		this.resultsContainer.empty();
		// toggle spinners
		$(iconSpinner).addClass('is-active');
		$pg.find('.error-messages').removeClass('is-active');

		This.initPostcodeSearchCall(storeList).then((data) => {
			if (data.result == 'SUCCESS') {
				let res = data.response;
				if ((res) && (res.length > 0)) {
					this.renderStoreList(res);
					this.handleStoreClick();
				} else {
					let errorMsg = 'Please search for a branch and select one from the autocomplete list. If no branch is found, please select a different address';
					$pg.find('.error-messages').addClass('is-active').text(errorMsg);
				}
				$(iconSpinner).removeClass('is-active');
			} else {
				// show error div
				$pg.find('.error-messages').addClass('is-active').text(data.message);
				$(iconSpinner).removeClass('is-active');
			}
		});
	}

	renderStoreList(list) {
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			let itemHtml = `
				<div class="regionStorePopup-trow ${item.fulfilmentNumber === `${this.storeInfo.storeId}` ? CLS_IS_SELECTED : ''}" data-id="${item.fulfilmentNumber}" data-content-link-id="${item.storeId}" data-name="${item.name}">
					<div class="regionStorePopup-tcell">
						<strong class="regionStorePopup-storeName">${item.name}</strong>
						<div>${item.address}</div>
						<div class="fsp-12">${item.hours}</div>
					</div>
					<button class="button-btn regionStorePopup-myStoreBtn"></button>
				</div>
			`;
			$(this.resultsContainer).append(itemHtml);
		}
		$(this.tableContainer).removeClass('d-none');
	}

	initPostcodeSearchCall(storeList = null) {
		const $pg = $(this.$el);
		let $branchSearchApiEndpoint = $pg.data('branchSearchApiEndpoint');
		let $data = {
			'branch': this.storeInfo.branchSearch,
		};

		if (storeList) {
			return checkout.getStoreList(storeList);
		} else {
			return Api.callApi($branchSearchApiEndpoint, $data);
		}
	}

	handleStoreClick() {
		$('.regionStorePopup-myStoreBtn').on('click', (e) => {
			let $target = $(e.target);
			let itemSelected = $target.closest('.regionStorePopup-trow');
			$('.regionStorePopup-trow.is-selected').removeClass(CLS_IS_SELECTED);
			itemSelected.addClass(CLS_IS_SELECTED);

			this.storeInfo.storeId = $(itemSelected).data('id');
			this.storeInfo.storeName = storeNameShorter($(itemSelected).data('name'));
			this.storeInfo.contentLinkID = $(itemSelected).data('content-link-id');
			this.regionDetail.addClass('selected');
			this.storeSelected.html(this.storeInfo.storeName);

			saveSelectedStore(this.storeInfo, () => {
				this.modal.modal('hide');

				dispatchEvent('[data-wg="StoreAvailNew"]', 'storeAvailNew.setRegion');
				dispatchEvent('[data-pg="ProductDetailsUpdate"]', 'pdp.setStore', {resetNearbyStore: true});
				dispatchEvent('.guaranteed-nextday-delivery', 'checkStoreVariantDetail');
				dispatchEvent('#mainContent', 'checkStoreVariantDetail');
				checkout.saveStoreSuccess();
			});
		});
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/widgets/regionStorePopup/js/regionStorePopup.js